<template>
  <div>
    <b-form-group class="custom-koeebox-checkbox">
      <template #label>
        <div v-if="isShowCheckAll">
          <label class="select-all-label text-muted">{{ selectAllLabel }}</label>
          <b-form-checkbox
            v-model="allSelectedItems"
            aria-describedby="options"
            aria-controls="options"
            @change="selectAll"
            id="all-options"
            class="custom-koeebox-checkbox"
          >
            <span class="checkbox-text">{{ selectAllValue }} ({{ options.length }})</span>
          </b-form-checkbox>
        </div>
      </template>
      <template v-slot="{ ariaDescribedby }">
        <div class="d-flex align-items-center input-search-box">
          <b-button variant="transparent" class="pl-0 koeebox-search-icon" @click="focusOnInput()">
            <svg-icon name="search-left" class="fill-icon" size="24"></svg-icon>
          </b-button>
          <b-form-input
            v-model="valueForFilter"
            :placeholder="placeholderInputs"
            class="text-muted custom-koeebox-input"
            ref="selectItems"
          ></b-form-input>
        </div>
        <div class="checkbox-group">
          <b-form-checkbox-group
            v-model="selectedItems"
            class="mb-3 custom-koeebox-checkbox clip"
            :class="{ 'remove-margin-top checkbox-items-with-icon': isShowCheckAll }"
            :aria-describedby="ariaDescribedby"
            value-field="value"
            text-field="name"
          >
            <b-form-checkbox
              v-for="checkboxOption in checkboxOptions"
              :key="checkboxOption.value"
              :value="checkboxOption.value"
              text-field="name"
              :aria-describedby="ariaDescribedby"
            >
              <div class="d-flex align-items-center">
                <span class="preview-thumbnail px-2 mt-0" v-if="isShowIcon">
                  <b-avatar
                    v-if="checkboxOption.image"
                    :src="checkboxOption.image"
                    variant=""
                    class="badge-transparent"
                    size="1.5rem"
                  ></b-avatar>
                  <b-avatar
                    v-else
                    class="bg-secondarygray badge-transparent"
                    variant=""
                    size="1.5rem"
                    :text="firstCharAvatar(checkboxOption.name)"
                  ></b-avatar>
                </span>
                <span class="checkbox-text">
                  {{ checkboxOption.name }}
                </span>
              </div>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </div>
        <p v-if="!checkboxOptions.length" class="text-muted text-center">
          {{ emptyOptionsText }}
        </p>
      </template>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'checkbox-group-select',
  props: {
    value: { required: true, type: Array },
    options: { required: true, type: Array },
    isShowIcon: { type: Boolean },
    isShowCheckAll: { type: Boolean },
    selectAllLabel: { type: String },
    selectAllValue: { type: String },
    emptyOptionsText: { type: String },
    placeholderInputs: { type: String },
  },
  data() {
    return {
      inputValue: '',
      allSelected: null,
    };
  },
  computed: {
    selectedItems: {
      get() {
        return this.value;
      },
      set(items) {
        this.$emit('input', items);
      },
    },
    allSelectedItems: {
      get() {
        if (this.allSelected != null) {
          return this.allSelected;
        }
        return this.options.length === this.value.length;
      },
      set(value) {
        this.allSelected = value;
      },
    },
    valueForFilter: {
      get() {
        return this.inputValue;
      },
      set(value) {
        this.inputValue = value;
      },
    },
    checkboxOptions() {
      return this.options.filter((option) => {
        return option.name.toLowerCase().indexOf(this.valueForFilter.toLowerCase()) > -1;
      });
    },
  },
  watch: {
    selectedItems(newValue) {
      if (newValue.length === 0) {
        this.allSelected = false;
      } else if (newValue.length === this.options.length) {
        this.allSelected = true;
      } else {
        this.allSelected = false;
      }
    },
  },
  methods: {
    focusOnInput() {
      this.$refs.selectItems.focus();
    },
    selectAll(checked) {
      let checkedOptions = [];
      if (checked) {
        this.options.forEach((option) => {
          checkedOptions.push(option.value);
        });
      } else {
        checkedOptions = [];
      }
      this.$emit('input', checkedOptions);
    },
    firstCharAvatar(name) {
      return name.charAt(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.koeebox-search-icon {
  padding-right: 10px;
}
.custom-koeebox-input {
  background-color: #191c24;
  border: none;
  padding-left: 0;
}
.input-search-box {
  padding: 5px 0px 0px 25px;
}
.remove-margin-top.custom-koeebox-checkbox :deep .custom-checkbox {
  &:first-child {
    margin-top: 0px;
  }
}
.custom-koeebox-checkbox :deep .custom-checkbox {
  padding: 10px 0px 10px 50px;
  margin-right: 0;
  &:first-child {
    margin-top: 20px;
  }
  label::before,
  label::after {
    cursor: pointer;
  }
  &:hover {
    background-color: #1c1f27;
  }
  .custom-control-input {
    cursor: pointer;
    display: block;
    width: 100%;
    height: 100%;
  }
  .preview-thumbnail {
    cursor: pointer;
  }
}
.checkbox-items-with-icon.custom-koeebox-checkbox :deep .custom-checkbox label span,
.checkbox-items-with-icon.custom-koeebox-checkbox :deep .custom-checkbox label .checkbox-text {
  padding-left: 0;
  margin-left: 0px;
}
.custom-koeebox-checkbox :deep .custom-checkbox label .checkbox-text {
  padding-left: 10px;
  margin-left: 0;
  max-width: 400px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
  margin-top: 3px;
  color: white;
}
.select-all-label {
  font-size: 16px;
}
.checkbox-group {
  &::-webkit-scrollbar-thumb {
    background-color: #ff6d0b;
    height: 80px;
  }
  &::-webkit-scrollbar {
    width: 3px;
  }
}
</style>
